module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/hairmake_sns_06-66ebb748290cf7b92547bf3edb381a79.jpg";